import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';

import { BetslipType } from '../../../../../core/betslip-type';
import { BestOddsGuaranteedToken, CriteriaType } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class MultiSlipTypeValidator extends TokensCriteriaValidatorBase<BestOddsGuaranteedToken, CriteriaType> {
    override type = CriteriaType.SlipType;

    isValid(token: BestOddsGuaranteedToken, state: TokenValidationInput): boolean {
        if (!token?.filter?.slipTypes?.length) {
            return true;
        }

        const currentSelectedType = state.selectedType;

        return token.filter.slipTypes.some((slipType) => {
            switch (slipType) {
                case BetSlipType.Single: {
                    return currentSelectedType === BetslipType.Single;
                }
                case BetSlipType.Combo: {
                    return currentSelectedType === BetslipType.Combo;
                }
                case BetSlipType.System: {
                    return currentSelectedType === BetslipType.System;
                }
            }
        });
    }
}
